import API from "../../api";
import { useCentralStore } from "../../store/appContext";
import { isEmpty } from "../../utils/functionUtils";
import { useEffect, useState } from 'react'
import moment from "moment";
import SGPLanding from "./SGPLanding";
import { getEnvByDomain } from "../../domain";

const LandingPage = ({ ActionTypes, resources }) => {
  const [{ userData, userDetails, saleMonthlyTrendData }, dispatch] = useCentralStore();

  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING, payload: action });
  };

  const gotoDashboard = (name, obj) => {
    dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: name });
    dispatch({ type: ActionTypes.SET_PROGRAM_NAME, data: name });
    dispatch({ type: ActionTypes.SET_PROJECT_NAME, payload: name });
    dispatch({ type: ActionTypes.SET_PROJECT_SUB_MENU, payload: obj });
    dispatch({ type: ActionTypes.SET_HEADER_TITLE, payload: obj?.label });

    if (name === 'Real Time Service Request Report') {
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });
      let startDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD 00:00:00')
      let endDate = moment(new Date()).format('YYYY-MM-DD 23:59:59')

      dispatch({
        type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
          type: 'dates',
          startDate: startDate,
          endDate: endDate,
          duration: 'dates'
        }
      })
    } else if ((name === 'Customer Service SLA Report') || name === ('Technical Service SLA Report') || name === ('Finance Reconciliation & Invoice') || name === ('Finance Reconciliation')) {
      const date = new Date();
      const currentMonth = date.getMonth(); // Get the current month (0-11)
      const currentYear = date.getFullYear(); // Get the current year

      // Determine previous month and year
      let month , year;

      if (currentMonth === 0) { // If it's January
        month = 12; // December of the previous year
        year = currentYear - 1; // Decrease the year by 1
      } else {
        month = currentMonth; // Current month minus 1
        year = currentYear; // Keep the same year
      }

      // Format the previous month as a two-digit string
      const formattedPrevMonth = `${month > 9 ? '' : '0'}${month}`;

      dispatch({
        type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
          type: 'month',
          startDate: undefined,
          endDate: undefined,
          duration: year + '-' + formattedPrevMonth
        }
      })
      if(name === 'Customer Service SLA Report' || name === 'Technical Service SLA Report') {
        let payload = {
          idToken: userData?.access_token,
          month: year + '-' + formattedPrevMonth
        };
  
        setLoading(true);
        API[ActionTypes.GET_SLA_REPORTS_DETAILS](payload, userDetails && userDetails?.email?.split("@")?.[0])
          .then(({ data }) => {
            setLoading(false);
            if (data) {
              dispatch({
                type: ActionTypes.GET_SLA_REPORTS_DETAILS_SUCCESS,
                payload: data,
              });
            }
          })
          .catch((err) => {
            dispatch({
              type: ActionTypes.GET_SLA_REPORTS_DETAILS_FAILURE,
              payload: err,
            });
            dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
            let _payload = {
              level: resources.POST_LOGGER_ERROR,
              category: resources.POST_LOGGER_API,
              ApiName: resources.POST_LOGGER_APINAME,
              message: {
                error: err,
                info: {
                  idToken: "",
                },
              },
            };
            API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
          }
          )
      }
       
    }

    if (name === 'Customer Service SLA Report') {
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });
    }

    if (name === 'Technical Service SLA Report') {
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });
    }

    if (name === 'Program Summary') {
      let payload = {
        // Username: userDetails && userDetails?.email?.split("@")?.[0],
        idToken: userData?.access_token,
      };

      setLoading(true);
      API[ActionTypes.GET_CHART_COUNT_DATA](payload, userDetails && userDetails?.email?.split("@")?.[0])
        .then(({ data }) => {
          setLoading(false);
          if (data) {
            dispatch({
              type: ActionTypes.GET_CHART_COUNT_DATA_SUCCESS,
              payload: data,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ActionTypes.GET_CHART_COUNT_DATA_FAILURE,
            payload: err,
          });
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
            level: resources.POST_LOGGER_ERROR,
            category: resources.POST_LOGGER_API,
            ApiName: resources.POST_LOGGER_APINAME,
            message: {
              error: err,
              info: {
                idToken: "",
              },
            },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
        });
    }
    if(name === 'Finance Reconciliation') {
      // dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });
    }
    if(name === 'Customer Value Management') {
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });
      // console.log('getEnvByDomain()', getEnvByDomain());
      // if(getEnvByDomain() !== 'local' || getEnvByDomain() !== 'qa') {
        // let payload = {}

        // API[ActionTypes.GET_CELCOM_CUSTOMER_VALUE_MGMT_DETAILS](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
        //     .then(({ data }) => {
        //         setLoading(false);
        //         if (data) {
        //             dispatch({ type: ActionTypes.SET_CELCOM_CUSTOMER_VALUE_MGMT_DATA, data: data?.GetCustomerValueManagementResponse });
        //         }
        //     })
        //     .catch((err) => {
        //         setLoading(false);
        //         dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        //         let _payload = {
        //             level: resources.POST_LOGGER_ERROR,
        //             category: resources.POST_LOGGER_API,
        //             ApiName: resources.POST_LOGGER_APINAME,
        //             message: {
        //                 error: err,
        //                 info: {
        //                     idToken: "",
        //                 },
        //             },
        //         };
        //         API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
        //     });
      // }
    }

    if (name === 'Sales Report') {
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: obj?.subLabels?.[0]?.value });

      const date = new Date();
      const currentMonth = date.getMonth(); // Get the current month (0-11)
      const currentYear = date.getFullYear(); // Get the current year

      // Determine previous month and year
      let month , year;

      if (currentMonth === 0) { // If it's January
        month = 12; // December of the previous year
        year = currentYear - 1; // Decrease the year by 1
      } else {
        month = currentMonth; // Current month minus 1
        year = currentYear; // Keep the same year
      }

      // Format the previous month as a two-digit string
      const formattedPrevMonth = `${month > 9 ? '' : '0'}${month}`;

      dispatch({
        type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
          type: 'month',
          startDate: undefined,
          endDate: undefined,
          duration: year + '-' + formattedPrevMonth
        }
      })
      
      // if (isEmpty(saleMonthlyTrendData)) {
      //   let payload = {
      //     ReportMonth: year + formattedPrevMonth,
      //     ReportType: 'monthly trend'
      //   }
      //   setLoading(true);
      //   API[ActionTypes.GET_SALES_BUSINESS_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      //     .then(({ data }) => {
      //       setLoading(false);
      //       if (data) {
      //         dispatch({ type: ActionTypes.SALES_REPORT_MONTHLY_TREND_DATA, payload: data?.SalesBusinessReportResponse })
      //       }
      //     })
      //     .catch((err) => {
      //       setLoading(false);
      //       dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
      //       let _payload = {
      //         level: resources.POST_LOGGER_ERROR,
      //         category: resources.POST_LOGGER_API,
      //         ApiName: resources.POST_LOGGER_APINAME,
      //         message: {
      //           error: err,
      //           info: {
      //             idToken: "",
      //           },
      //         },
      //       };
      //       API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      //     });
      // }
    }
  }

  return (
    <>
      <div className={`flex flex-col items-center justify-center h-4/5`}>
        <div className={'flex flex-row flex-wrap justify-center mt-5 w-full'}>
          <SGPLanding
            resources={resources}
            gotoDashboard={(pgmName, obj) => gotoDashboard(pgmName, obj)}
            userDetails={userDetails}
          />

        </div>
      </div>
    </>
  );
};

export default LandingPage;
